// extracted by mini-css-extract-plugin
export default {"App":"App_App__2+VHF","App__Header":"App_App__Header__MG2Ia","App__Footer":"App_App__Footer__lASr-"};